import React from 'react'
import {Col, Image} from 'react-bootstrap'
import { Text } from 'react-form'
import {PersianNumber} from 'react-persian'

export default ({products, setValue}) => {
  return (
    <div>
      {products.map((product, index) => (
        <Col key={index} md={5} mdOffset={1} xs={12} className="donate-description">
          <Image src={product.image} alt={product.title} />
          <h2><PersianNumber>{product.price.toLocaleString()}</PersianNumber> تومان</h2>
          <Text className="form-control" type="number" field={`p_${product.id}`} onChange={(e) => setValue(`p_${product.id}`, parseInt(e.target.value, 10))} min="0" max={product.count} />
          <p><PersianNumber>{product.count}</PersianNumber> {product.title} باقی مانده است.</p>
        </Col>
      ))}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Donate/ProductForm.js